/* eslint-disable @typescript-eslint/no-unused-expressions */
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
const DEFAULT_SENTRY_ENV = 'UNSPECIFIED';
const { SENTRY_DSN, SENTRY_ENV = DEFAULT_SENTRY_ENV } = process.env;
export const initSentry = (options) => {
    SENTRY_DSN !== ''
        && Sentry.init(Object.assign({ dsn: SENTRY_DSN, integrations: [new Integrations.BrowserTracing()], environment: SENTRY_ENV, whitelistUrls: [/nykaafashion\.com/i, /nykaaman\.com/i, /nykaa\.com/i], denyUrls: [], ignoreErrors: [] }, options));
};
export const log = ({ error, message, tags, extraInfo, }) => {
    Sentry.withScope((scope) => {
        extraInfo && scope.setExtras(extraInfo);
        tags && scope.setTags(tags);
        if (message) {
            Sentry.captureMessage(message, Sentry.Severity.Error);
            return;
        }
        Sentry.captureException(error);
    });
};
export const info = ({ information, tags, extraInfo }) => {
    Sentry.withScope((scope) => {
        scope.setLevel(Sentry.Severity.Info);
        extraInfo && scope.setExtras(extraInfo);
        tags && scope.setTags(tags);
        Sentry.captureException(information);
    });
};
export const setCustomScope = (identifier, value) => {
    Sentry.configureScope((scope) => {
        scope.setTag(identifier, value);
    });
};
export const captureEvent = (exception) => {
    Sentry.captureEvent(exception);
};
export const setUserScope = (userOptions) => {
    Sentry.configureScope((scope) => {
        scope.setUser(userOptions);
    });
};
export default Sentry;
